import { trainersApi, TrainerWorkHistoryApi } from "api/trainers/trainersApi";
import { useEffect, useState } from "react";

export const useTrainerWorkHistory = (trainerId: number) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<TrainerWorkHistoryApi>();

  useEffect(() => {
    const fetchResource = async () => {
      const res = await trainersApi.fetchWorkHistory(trainerId);
      try {
        setData(res.data);
      } catch (error) {
        // Handle error appropriately, perhaps with another state variable
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchResource();
  }, [trainerId]);

  return { loading, data };
};
